import { PageOptions, PaginatedResponse } from '../api.types';
import { EmailParticipant, EmailParticipantType } from '../email-sync/email-sync.types';

export interface Comment {
  id: string;
  content: string;
  type: CommentType;
  is_edited: boolean;
  data: ICommentData;
  /** JT1-1596: the note's configured type. Absent on chat, email and meeting comments. */
  note_type?: CommentNoteType;
  created_at: string;
  updated_at: string;
  account: CommentAccount;
}

export interface CommentNoteType {
  id: string;
  name: string;
  icon: string;
  colour: string;
  system_key: string | null;
}

export interface ICommentData {
  text?: string;
  activity?: ICommentActivityType;
  email?: ICommentEmailType;
  meeting?: ICommentMeetingType;
  tagged_accounts?: CommentAccount[];
}

export interface ICommentMeetingType {
  meeting_id: string;
  summary: string;
}

export interface ICommentActivityType {
  /**
   * JT1-1596: superseded by note_type_id when posting, and by Comment.note_type when reading. Still
   * written by the server for one release, so anything reading it keeps working.
   */
  type?: CommentActivityType;
  note_type_id?: string;
  text: string;
}

export interface ICommentEmailType {
  message_id: string;
  type: EmailParticipantType;
  content: string;
  from: EmailParticipant[];
  to: EmailParticipant[];
  cc?: EmailParticipant[];
  bcc?: EmailParticipant[];
  attachments?: {
    id: string;
    filename: string;
    mime_type: string;
    public_path: string;
  }[];
}

export enum CommentActivityType {
  GENERAL = 'general',
  PHONE_CALL = 'phone_call',
  CALL_RECEIVED = 'call_received',
  MEETING = 'meeting',
}

export enum CommentType {
  TEXT = 'text',
  ACTIVITY = 'activity',
  EMAIL = 'email',
  MEETING = 'meeting'
}

export enum ThreadType {
  CHAT = 'chat',
  NOTES = 'notes'
}

export interface CommentAccount {
  id: string;
  first_name: string;
  last_name: string;
  /** True for a guest-portal stakeholder — an external reviewer, not a member of the org. */
  is_guest?: boolean;
}

export type GetThreadProps = {
  thread_id: string;
} & PageOptions;

export interface PostCommentProps {
  thread_id: string;
  type: CommentType;
  data: ICommentData;
}

export type GetCommentsResponse = PaginatedResponse<Comment>;

export interface IThread {
  id: string;
  type: ThreadType;
  created_at: string;
};

export type AttachedThread = {
  id: string;
  last_activity_at?: Date;
};
